import { Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BaseUpdateComponent, BaseDataService, QueryParameter, NotificationService } from 'yt-ng-framework';
import { Component, OnInit } from '@angular/core';
// import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
import { KozDokument } from './koz-dokument';
import { List } from 'immutable';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-koz-dokument-update',
  templateUrl: './koz-dokument-update.component.html'
})
export class KozDokumentUpdateComponent 
extends BaseUpdateComponent<KozDokument> 
implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService
  ) { 
    super(activatedRoute, baseDataService, toastrService, translateService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.addValidatorToFc('PodVrstaDokumentaStavkaID',Validators.required, 'required', 'KOZDOKUMENT.PODVRSTADOKUMENTASTAVKA.VALIDATION.REQUIRED');
    this.addValidatorToFc('KomitentID',Validators.required, 'required', 'KOZDOKUMENT.KOMITENT.VALIDATION.REQUIRED');
    this.addValidatorToFc('TarifaID',Validators.required, 'required', 'KOZDOKUMENT.TARIFA.VALIDATION.REQUIRED');
    this.addValidatorToFc('Broj',Validators.required, 'required', 'KOZDOKUMENT.BROJDOKUMENTA.VALIDATION.REQUIRED');
    this.addValidatorToFc('Datum',Validators.required, 'required', 'KOZDOKUMENT.DATUM.VALIDATION.REQUIRED');


    this.IDProcessed
    .subscribe(() => {
        if (this.Item.ID == -1) {
            let dateNow = new Date();
            let date: NgbDate = new NgbDate(dateNow.getFullYear(), dateNow.getMonth() + 1, dateNow.getDate());
            this.baseFormGroup.patchValue({ Datum: date });
            this.baseFormGroup.get('Datum').updateValueAndValidity();
        }
    })
  }

  onPodVrstaSelect() {
    this.getBrojDokumenta();
}

getBrojDokumenta() {
  let podvrstaid = this.baseFormGroup.get('PodVrstaDokumentaStavkaID').value;
  let datum = this.baseFormGroup.get('Datum').value;
  if (this.Item.ID == -1 && podvrstaid && datum)
      this.baseDataService.GetData('KozDokument', 'KreirajBrojDokumenta', { 'PodVrstaDokumentaStavkaID': podvrstaid, 'Datum': datum })
          .subscribe(data => {
              this.baseFormGroup.patchValue({ Broj: data });
              this.baseFormGroup.get('Broj').updateValueAndValidity();
          })

}

  editMode: boolean=false;
  AddDocument() { }
  //Print(ID1) {}
  item:any;
  PrintKnj(item1){}
  SaveMaster(qq){}
  onDatumChange(value) {
    if (value != null) {
        let parameterList: List<QueryParameter> = List([new QueryParameter('Datum', value)]);
        this.TransferParameters = this.TransferParameters.set(0, parameterList);
        this.getBrojDokumenta();
    }
}


}
